<template>
    <one-column-layout class="login dark">
      <div class="pogs-panel">
        <header>
          <a href="https://www.pogsinc.org/" target="_blank"><div class="pogs-branding"></div></a>
          <h2>POGS Nationwide Census</h2>
        </header>

        <div class="content">
          <div class="form__col">
            <label>Username</label>
            <input type="text" placeholder="Username" v-model="username"/>
            <label>Password</label>
            <input type="password" placeholder="Password" v-model="password"/>
            <smd-btn @click="login">Login</smd-btn>
          </div>
        </div>
        <div class="sub-header">
          <label>Powered by</label>
          <a href="https://seriousmd.com" target="_blank"><div class="smd-branding"></div></a>
        </div>
      </div>
    </one-column-layout>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    ACTION_AUTHENTICATE_USER,
    GETTER_AUTHENTICATED_USER
  } from '../../../store/modules/accounts'
  import Routes from '../../../router/route-constants'

  export default {
    data(){
      return{
        username: null,
        password: null
      }
    },
    computed: {
      ...mapGetters({
        auth_info: GETTER_AUTHENTICATED_USER
      })
    },
    methods: {
      login(){
        const payload = {
          username: this.username,
          password: this.password
        };
        this.$store.dispatch(ACTION_AUTHENTICATE_USER, payload)
          .then(()=> {
            if(this.auth_info.user){
              console.log(this.auth_info.message);
              localStorage.setItem('pogs-user-token', 'Bearer ' + this.auth_info.token);
              localStorage.setItem('pogs-user-permissions', JSON.stringify(this.auth_info.user.permissions));
              console.log(localStorage.getItem('pogs-user-permissions'));
              this.$emit('logged-in')
              this.$router.push({name: Routes.ROOT_ROUTE_CASES})
            }else{
              this.$toasted.show(this.auth_info.message);
            }
          })
          .catch((err) => {
            this.$toasted.show("Error communicating with server: " + err);
          });
      }
    }
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .login{
    .page__content{
      @extend %flex-row--center-xy;
      height: 100vh;
    }

    .pogs-panel{
      margin: auto;
      min-width: 380px;

      header{
        justify-content: center;
        flex-direction: column;
        h2{
          @extend %user-no-select;
          padding: space(m) 0 0 0;
        }
        .pogs-branding{
          margin-top: space(m);
          height: 150px;
          width: 150px;
        }
      }

      .content{
        padding: space(m);
        button{
          margin-top: space(s);
          max-width: 100px;
          align-self: center;
        }
      }

      .sub-header{
        @extend %flex-row--center-xy;
        margin-top: space(s);
        margin-bottom: space(s);
        padding: space(s) 0;
        label{margin-right: space(s);}
      }
    }


    input:focus::-webkit-input-placeholder { color:transparent !important; }
    input:focus:-moz-placeholder { color:transparent !important; } /* FF 4-18 */
    input:focus::-moz-placeholder { color:transparent !important; } /* FF 19+ */
    input:focus:-ms-input-placeholder { color:transparent !important; } /* IE 10+ */
  }

</style>
